import React, { FC } from 'react'

import { WHEN_TO_START_USING_SIM } from '@smarty-nx/code-utils'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import cn from 'classnames'

import { content } from './info-footer.content'
import classes from './info-footer.module.scss'
import { Typography } from '../typography/typography'

interface InfoFooterProps {
  src?: string
  description?: string
  linkLabel?: string
  className?: string
  linkDataItemName?: string
  linkDataItemCategory?: string
}

export const InfoFooter: FC<InfoFooterProps> = ({
  description = content.whenInsertSim,
  linkLabel = content.learnMore,
  src = WHEN_TO_START_USING_SIM,
  className,
  linkDataItemName = 'learn-more',
  linkDataItemCategory = TRACKING_CATEGORIES.NAVIGATION,
}) => {
  return (
    <div className={cn(classes.root, className)}>
      {description && (
        <Typography
          className={classes.description}
          variant="Kollektif/ExtraSmall"
        >
          {description}
        </Typography>
      )}
      <a
        className={classes.link}
        href={src}
        target="_blank"
        rel="noopener noreferrer"
        data-item-name={linkDataItemName}
        data-item-category={linkDataItemCategory}
      >
        {linkLabel}
      </a>
    </div>
  )
}
